import type { KitchenProduct } from '@/types'

function calculateUniqueId(
  catalogProductId?: string,
  tabProductId?: string,
  modifiers?: {
    catalogModifierId?: string
    name?: string
    quantity: number
  }[],
  comments?: string,
  comboId?: string,
  combineCombo?: boolean,
  comboName?: string
) {
  const modifierIds = (modifiers || [])
    .map(modifier => (modifier.catalogModifierId || modifier.name) + ',' + modifier.quantity)
    .sort()
  const id =
    (catalogProductId || tabProductId) +
    modifierIds.join(',') +
    comments +
    (combineCombo ? comboName : comboId)

  return id
}

function group(products: KitchenProduct[]) {
  const groupedProducts = products.reduce(
    (res, product) => {
      const { catalogProductId, tabProductId, ...productInfo } = product
      const id = calculateUniqueId(
        catalogProductId,
        tabProductId,
        product.modifiers,
        product.comments,
        product.comboId,
        product.combine,
        product.comboName
      )
      const previous = res[id] || { quantity: 0, tabProductIds: [] }
      res[id] = {
        ...productInfo,
        tabProductIds: [...previous.tabProductIds, tabProductId],
        quantity: product.quantity + previous.quantity
      }
      return res
    },
    {} as Record<
      string,
      Omit<KitchenProduct, 'tabProductId' | 'catalogProductId'> & {
        tabProductIds: string[]
        quantity: number
      }
    >
  )
  return Object.values(groupedProducts).map(product => {
    const { tabProductIds, ...productInfo } = product
    return {
      groupedId: tabProductIds.sort().join(','),
      ...productInfo
    }
  })
}

export default {
  group
}
